/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Select_All_ApplyInputs */

const en_mobile_select_all_apply = /** @type {(inputs: Mobile_Select_All_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all that apply`)
};

const es_mobile_select_all_apply = /** @type {(inputs: Mobile_Select_All_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona todo lo que corresponda`)
};

/**
* | output |
* | --- |
* | "Select all that apply" |
*
* @param {Mobile_Select_All_ApplyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_select_all_apply = /** @type {((inputs?: Mobile_Select_All_ApplyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Select_All_ApplyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_select_all_apply(inputs)
	return en_mobile_select_all_apply(inputs)
});